(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BL-New-Pop-Up"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aim-community-overlay')) {
  class AIMCommunityOverlay extends HTMLElement {
    static regionFor(regions, country) {
      if (!country) return null;
      const codes = r => String(r.countries || '').toUpperCase().split(/[\s,;]+/).filter(Boolean);
      // Exact country match first; otherwise a "Rest of world" block with countries set to *
      const found = regions.find(r => codes(r).includes(country.toUpperCase())) || regions.find(r => codes(r).includes('*'));
      return found?.enabled ? found : null;
    }
    static identityAllowed(identified, exclude, strict) {
      return !exclude || identified === false || (identified === null && !strict);
    }
    static triggerReady(mode, delayed, scrolled, exited) {
      return mode === 'delay' ? delayed : mode === 'scroll' ? scrolled : mode === 'both' ? delayed && scrolled : mode === 'either' ? delayed || scrolled : mode === 'exit' ? delayed && exited : false;
    }
    static subscriptionBody(email, list, meta) {
      const subscriptions = {email: {marketing: {consent: 'SUBSCRIBED'}}};
      const attributes = {
        email: email.trim(),
        subscriptions,
        properties: {
          aim_popup_variant: meta.variant,
          aim_popup_entry: meta.entry,
          aim_popup_region: meta.region,
          aim_popup_country: meta.country,
          aim_popup_offer: meta.offer
        }
      };
      return {
        data: {
          type: 'subscription',
          attributes: {custom_source: 'AIM community overlay', profile: {data: {type: 'profile', attributes}}},
          relationships: {list: {data: {type: 'list', id: list}}}
        }
      };
    }
    // Theme editor state lives on the preview window, NOT in sessionStorage.
    // It survives section re-renders (setting changes, region rebuilds) but resets on every
    // full page load, so opening the customiser never auto-opens the pop-up. It only shows
    // once the section or one of its blocks is actually selected in the sidebar.
    static editorState() {
      if (!window.__aimCommunityEditor) window.__aimCommunityEditor = {open: null, region: null};
      return window.__aimCommunityEditor;
    }

    connectedCallback() {
      if (this.started) return;
      this.started = true;
      if (!this.pristine) this.pristine = this.outerHTML;
      this.abort = new AbortController();
      this.timers = [];
      this.config = JSON.parse(this.dataset.config);
      this.dialog = this.querySelector('dialog');
      this.panel = this.querySelector('.aimc-panel');
      this.form = this.querySelector('.aimc-form');
      this.teaser = this.querySelector('[data-teaser]');
      this.preview = this.dataset.editor === 'true';
      this.config.klaviyo_form_id = String(this.config.klaviyo_form_id || '').trim();
      this.klaviyoEmbed = this.querySelector('[data-klaviyo-embed]');
      this.regions = [...this.querySelectorAll('[data-region]')].map(el => ({...JSON.parse(el.dataset.config), id: el.dataset.region, element: el}));
      this.storagePrefix = 'aim-community:';
      this.entry = 'auto';
      if (this.preview) this.clearLegacyEditorKeys();

      this.listen(this.querySelector('[data-close]'), 'click', () => this.close());
      this.listen(this.dialog, 'cancel', e => {e.preventDefault(); this.close();});
      this.listen(this.dialog, 'click', e => {if (e.target === this.dialog) this.close();});
      this.listen(window, 'resize', () => this.syncViewport(), {passive:true});
      this.listen(window.visualViewport, 'resize', () => this.syncViewport(), {passive:true});
      this.listen(window.visualViewport, 'scroll', () => this.syncViewport(), {passive:true});
      this.listen(this.dialog, 'focusin', () => requestAnimationFrame(() => this.syncViewport()));
      this.listen(this.dialog, 'focusout', () => requestAnimationFrame(() => this.syncViewport()));
      this.listen(this.querySelector('[data-teaser-open]'), 'click', () => {this.entry = 'teaser'; this.emit('teaser_open'); this.open();});
      this.listen(this.querySelector('[data-teaser-close]'), 'click', () => this.dismiss());
      this.listen(this.querySelector('[data-copy]'), 'click', () => this.copyCode());
      this.listen(this.querySelector('[data-preview-sms]'), 'click', () => this.finishSignup());
      this.listen(this.querySelector('[data-sms-skip]'), 'click', () => this.finishSignup());
      this.listen(this.querySelector('[data-sms-loading-skip]'), 'click', () => this.finishSignup());
      this.listen(this.querySelector('[data-next]'), 'click', () => {this.setStep('email'); this.emit('step'); this.emailField()?.focus();});
      this.listen(this.querySelector('[data-back]'), 'click', () => {this.setStep('intro'); this.querySelector('[data-next]').focus();});
      this.listen(this.querySelector('[data-shop]'), 'click', e => {
        if (this.preview) {e.preventDefault(); const status = this.querySelector('[data-copy-status]'); if (status) status.textContent = this.dataset.demo;}
      });
      if (!this.config.klaviyo_form_id) {
        this.listen(this.form, 'submit', e => {e.preventDefault(); this.submit();});
      } else if (this.preview) {
        this.listen(this.querySelector('[data-submit]'), 'click', e => {e.preventDefault(); this.submit();});
      } else {
        this.listen(window, 'klaviyoForms', e => this.klaviyoSubmitted(e));
        this.listen(this.klaviyoEmbed, 'click', e => {
          const button = e.target.closest('button');
          if (this.dataset.step === 'sms' && button?.textContent.trim() === 'Skip for now') this.later(() => this.finishSignup(), 0);
          if (this.dataset.step === 'sms' && button?.textContent.trim() === 'Sign up for texts') this.smsSubmissionPending = true;
        }, {capture: true});
        this.embedObserver = new MutationObserver(() => this.syncEmbed());
        if (this.klaviyoEmbed) this.embedObserver.observe(this.klaviyoEmbed, {childList: true, subtree: true});
        this.syncEmbed();
      }
      this.listen(this.form, 'input', e => {if (e.target.getAttribute('aria-invalid')) e.target.removeAttribute('aria-invalid');});
      this.listen(document, 'click', e => {
        const trigger = e.target.closest('[data-aim-community-open]');
        if (trigger) {e.preventDefault(); this.entry = 'manual'; this.attemptOpen(true);}
      });
      this.listen(document, 'visitorConsentCollected', () => this.start());
      this.listen(document, 'visibilitychange', () => {if (!document.hidden) this.attemptOpen(false);});
      this.listen(document, 'shopify:section:select', e => {
        if (!this.preview || e.detail?.sectionId !== this.dataset.sectionId) return;
        this.setPreviewOpen(true);
        // Selecting the section itself goes back to the Preview country setting.
        if (this.previewRegionId()) {this.setPreviewRegion(null); return this.rebuild();}
        this.showPreview();
      });
      // Selecting a region block previews that region (e.g. Rest of world).
      this.listen(document, 'shopify:block:select', e => {
        if (!this.preview || e.detail?.sectionId !== this.dataset.sectionId) return;
        if (!this.regions.some(r => r.id === e.detail.blockId)) return;
        this.setPreviewOpen(true);
        if (this.region?.id === e.detail.blockId && this.dialog.open) return;
        this.setPreviewRegion(e.detail.blockId);
        this.rebuild();
      });
      this.listen(document, 'shopify:section:deselect', e => {
        if (this.preview && e.detail?.sectionId === this.dataset.sectionId) {this.setPreviewOpen(false); this.setPreviewRegion(null); this.hideAll();}
      });
      this.start();
    }

    // ----- Theme editor helpers -----
    previewRegionId() {
      return AIMCommunityOverlay.editorState().region;
    }
    setPreviewRegion(id) {
      AIMCommunityOverlay.editorState().region = id || null;
    }
    previewOpen() {
      return AIMCommunityOverlay.editorState().open === this.dataset.sectionId;
    }
    setPreviewOpen(on) {
      AIMCommunityOverlay.editorState().open = on ? this.dataset.sectionId : null;
    }
    // Older versions stored editor state in sessionStorage, which survived reloads and
    // made the pop-up open every time the customiser loaded. Remove those leftovers.
    clearLegacyEditorKeys() {
      try {
        sessionStorage.removeItem('aim-community:preview-open');
        sessionStorage.removeItem('aim-community:preview-region');
      } catch {}
    }
    // Editor only: swap in a fresh copy so a different region's copy applies cleanly.
    rebuild() {
      const t = document.createElement('template');
      t.innerHTML = this.pristine;
      const fresh = t.content.firstElementChild;
      fresh.pristine = this.pristine;
      this.replaceWith(fresh);
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.embedObserver?.disconnect();
      this.requestAbort?.abort();
      this.timers?.forEach(clearTimeout);
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      this.started = false;
    }
    listen(target, event, handler, extra = {}) {
      if (target) target.addEventListener(event, handler, {...extra, signal: this.abort.signal});
    }
    later(fn, ms) {const id = setTimeout(fn, ms); this.timers.push(id); return id;}

    // ----- Storage -----
    allowed(kind) {
      try {return window.Shopify?.customerPrivacy?.[kind + 'ProcessingAllowed']?.() === true;} catch {return false;}
    }
    // Long-lived (localStorage) values: only with the visitor's consent.
    read(key, kind = 'preferences') {
      if (!this.allowed(kind)) return null;
      try {return localStorage.getItem(this.storagePrefix + key);} catch {return null;}
    }
    write(key, value, kind = 'preferences') {
      if (!this.allowed(kind)) return false;
      try {localStorage.setItem(this.storagePrefix + key, String(value)); return true;} catch {return false;}
    }
    // Session-only UX flags (cleared when the tab closes). These record the visitor's own
    // choices (dismissed, subscribed, already shown) and do not wait on consent, otherwise
    // visitors who haven't answered the cookie banner see the teaser again on every page.
    sessionFlag(key) {
      try {return sessionStorage.getItem(this.storagePrefix + key) === '1';} catch {return false;}
    }
    setSessionFlag(key) {
      try {sessionStorage.setItem(this.storagePrefix + key, '1');} catch {}
    }

    async privacyReady() {
      if (window.Shopify?.customerPrivacy) return;
      if (window.Shopify?.loadFeatures) await Promise.race([
        new Promise(resolve => window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], resolve)),
        new Promise(resolve => this.later(resolve, 3000))
      ]);
    }
    async identity() {
      if (!this.config.hide_identified) return false;
      return new Promise(resolve => {
        let finished = false;
        const finish = v => {if (!finished) {finished = true; resolve(typeof v === 'boolean' ? v : null);}};
        this.later(() => finish(null), 4000);
        try {
          if (typeof window.klaviyo?.isIdentified === 'function') {
            Promise.resolve(window.klaviyo.isIdentified()).then(finish, () => finish(null));
          } else {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['isIdentified', finish]);
          }
        } catch {finish(null);}
      });
    }

    emailField() {
      return this.form.querySelector('input[type="email"]');
    }
    syncEmbed() {
      if (!this.klaviyoEmbed) return;
      this.styleEmbedButton();
      this.klaviyoEmbed.querySelectorAll('button').forEach(button => {
        if (button.textContent.trim() !== 'Skip for now') return;
        button.setAttribute('data-aimc-skip', '');
        button.closest('[data-testid="form-component"]')?.setAttribute('data-aimc-skip-block', '');
      });
      if (this.pendingOpen && this.klaviyoEmbed.querySelector('input[type="email"]')) {
        this.pendingOpen = false;
        requestAnimationFrame(() => {if (this.isConnected && !this.dismissed) this.open();});
      }
      if (this.dataset.step !== 'sms' || this.preview) return;
      const phone = this.klaviyoEmbed.querySelector('input[type="tel"]');
      if (phone) {
        this.smsFieldMounted = true;
        this.klaviyoEmbed.hidden = false;
        this.querySelector('[data-sms-loading]').hidden = true;
      } else if (this.smsFieldMounted && this.nativeSignupComplete()) {
        // The native success screen can be empty. Use its completed render as a
        // fallback if Klaviyo omits phone metadata from the step event.
        requestAnimationFrame(() => {
          if (this.dataset.step === 'sms' && this.nativeSignupComplete()) {
            this.smsRequested = Boolean(this.smsSubmissionPending);
            this.finishSignup();
          }
        });
      }
    }
    nativeSignupComplete() {
      const form = this.klaviyoEmbed?.querySelector('form');
      return Boolean(form && !form.querySelector('input[type="email"],input[type="tel"],button.klaviyo-form-button'));
    }
    styleEmbedButton() {
      if (!this.klaviyoEmbed || this.dataset.step === 'sms') return;
      const label = this.dataset.step === 'email'
        ? (this.region?.no_offer ? this.config.noffer_email_button || this.config.email_button : this.config.email_button)
        : this.region?.button || this.config.button;
      this.klaviyoEmbed.style.setProperty('--aimc-embed-button', JSON.stringify(label || 'Join now'));
      const button = this.klaviyoEmbed.querySelector('button');
      if (button && button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label || 'Join now');
    }
    smsAvailable() {
      const countries = String(this.config.sms_countries || '').toUpperCase().split(/[\s,;]+/);
      return Boolean(this.config.sms_enabled && this.config.klaviyo_form_id && countries.includes(this.country));
    }
    finishSignup() {
      if (!this.submitted && !this.preview) return;
      this.setStep('success');
      this.querySelector('[data-success-heading]').focus();
    }
    klaviyoSubmitted(e) {
      const detail = e.detail;
      if (this.preview || !this.isConnected || !this.dialog.open || this.form.hidden) return;
      if (String(detail?.formId) !== this.config.klaviyo_form_id) return;
      if (this.submitted) {
        if (this.dataset.step === 'sms' && ['stepSubmit', 'submit'].includes(detail.type) && detail.metaData?.phone_number) {
          this.smsRequested = true;
          this.finishSignup();
        }
        return;
      }
      if (detail.type !== 'submit') return;
      this.panel.style.minHeight = this.panel.offsetHeight + 'px';
      this.submitted = true;
      this.write('subscribed-until', Date.now() + 365 * 86400000);
      this.setSessionFlag('subscribed');
      this.emit('request_accepted');
      this.hideTeaser();
      this.setStep(this.smsAvailable() ? 'sms' : 'success');
      this.querySelector(this.dataset.step === 'sms' ? '[data-sms-heading]' : '[data-success-heading]').focus();
      const properties = {
        aim_popup_variant: 'A',
        aim_popup_entry: this.entry,
        aim_popup_region: this.region?.name,
        aim_popup_country: this.country,
        aim_popup_offer: this.region?.no_offer ? 'none' : 'first_order_free_shipping'
      };
      const email = String(detail.metaData?.email || this.emailField()?.value || '').trim();
      try {
        if (typeof window.klaviyo?.identify === 'function') {
          Promise.resolve(window.klaviyo.identify(email ? {...properties, email} : properties)).catch(() => {});
        } else {
          window._learnq = window._learnq || [];
          window._learnq.push(['identify', email ? {...properties, $email: email} : properties]);
        }
      } catch {}
    }

    async start() {
      if (this.starting || this.ready || this.dismissed || this.submitted || !this.isConnected) return;
      this.starting = true;
      const c = this.config;
      try {
        if (this.preview) {
          this.country = String(c.preview_country || '').toUpperCase();
          const picked = this.previewRegionId();
          this.region = this.regions.find(r => r.id === picked) || AIMCommunityOverlay.regionFor(this.regions, this.country) || this.regions.find(r => r.enabled);
          if (!this.region) return;
          this.applyRegion();
          this.variant = 'A';
          this.ready = true;
          // Only re-show after a section re-render while the section is selected — never on page load.
          if (this.previewOpen()) this.showPreview();
          return;
        }
        if (!c.enabled || this.dataset.customerExcluded === 'true' || !c.site_id || !c.list_id) return;
        // Dismissed (teaser X) or subscribed earlier this visit: stay hidden on every page.
        if (this.sessionFlag('dismissed') || this.sessionFlag('subscribed')) return;
        const path = location.pathname.replace(new RegExp('^' + this.dataset.root.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')), '/');
        if (String(c.exclude_paths).split(/[\n,]+/).some(p => p.trim() && path.startsWith(p.trim()))) return;
        await this.privacyReady();
        let geo = '';
        try {geo = window.Shopify?.customerPrivacy?.getRegion?.() || '';} catch {}
        // Fall back to the Shopify market country when detection is unavailable, instead of hiding.
        this.country = String((c.country_source === 'detected' && geo ? geo.slice(0, 2) : this.dataset.country) || '').toUpperCase();
        this.region = AIMCommunityOverlay.regionFor(this.regions, this.country);
        if (!this.region) return;
        if (!this.region.no_offer && !String(this.region.discount_code || c.discount_code || '').trim()) return;
        this.applyRegion();

        const identified = await this.identity();
        if (!AIMCommunityOverlay.identityAllowed(identified, c.hide_identified, c.strict_identity)) return;
        // Re-check after the awaits: the visitor may have dismissed in another tab meanwhile.
        if (this.sessionFlag('dismissed') || this.sessionFlag('subscribed')) return;
        const now = Date.now();
        if (Number(this.read('dismissed-until') || 0) > now || Number(this.read('subscribed-until') || 0) > now) return;

        let canPersist = this.allowed('analytics');
        if (canPersist) canPersist = this.write('storage-check', '1', 'analytics');
        this.variant = 'A';
        this.measurable = canPersist;
        this.ready = true;

        // Closed the modal earlier: stay minimised as a teaser instead of re-opening the modal.
        if (c.teaser_enabled && (this.sessionFlag('minimised') || Number(this.read('minimised-until') || 0) > now)) {
          this.autoDone = true;
          this.showTeaser();
          return;
        }
        // Already auto-opened earlier this session: only the teaser from now on.
        if (this.sessionFlag('auto-shown')) {
          this.autoDone = true;
          this.showTeaser();
          return;
        }
        // Corner teaser shows straight away; the full pop-up follows when the trigger is met.
        if (c.teaser_enabled && c.teaser_on_load) this.showTeaser();
        if (!this.triggersStarted) {
          this.triggersStarted = true;
          this.later(() => {this.delayed = true; this.attemptOpen(false);}, c.delay_seconds * 1000);
          this.listen(window, 'scroll', () => this.attemptOpen(false), {passive: true});
          this.listen(document, 'mouseout', e => {if (!e.relatedTarget && e.clientY <= 0) {this.exited = true; this.attemptOpen(false);}});
        }
        this.attemptOpen(false);
      } finally {
        this.starting = false;
      }
    }

    applyRegion() {
      const r = this.region;
      const map = {heading: '[data-heading]', body: '[data-body]', shipping: '[data-shipping]', button: '[data-join-label]', terms: '[data-terms], [data-success-terms]', teaser_heading: '[data-teaser-title]'};
      for (const [key, selector] of Object.entries(map)) {
        if (r[key]) this.querySelectorAll(selector).forEach(el => el.textContent = r[key]);
      }
      if (r.no_offer) this.applyNoOffer();
      const art = r.element.querySelector('[data-region-art]');
      if (art?.content.children.length) this.querySelector('[data-mobile-art]')?.replaceChildren(art.content.cloneNode(true));
      if (art?.content.children.length) {
        const target = this.querySelector('[data-art]');
        target.replaceChildren(art.content.cloneNode(true));
        target.classList.add('aimc-art--single');
      }
      const thumb = r.element.querySelector('[data-region-thumb]');
      if (thumb?.content.children.length) this.querySelector('[data-teaser-media]').replaceChildren(thumb.content.cloneNode(true));
    }

    // Sign-up only (no discount): swap in the no-offer copy and hide every offer element.
    applyNoOffer() {
      const r = this.region, c = this.config;
      const set = (selector, value) => {if (value) this.querySelectorAll(selector).forEach(el => el.textContent = value);};
      set('[data-heading]', r.heading || c.noffer_heading);
      set('[data-body]', r.body || c.noffer_body);
      set('[data-teaser-title]', r.teaser_heading || c.noffer_teaser_heading);
      set('[data-email-heading]', c.noffer_email_heading);
      set('[data-email-subtext]', c.noffer_email_subtext);
      set('[data-success-heading]', c.noffer_success_heading);
      set('[data-success-body]', c.noffer_success_body);
      set('[data-success-label]', c.noffer_success_button);
      // Replace the benefit list with the no-offer benefits (keeps the same tick icon).
      const list = this.querySelector('.aimc-benefits');
      const tick = list?.querySelector('.aimc-tick');
      const items = [c.noffer_benefit_one, c.noffer_benefit_two, c.noffer_benefit_three].map(v => String(v || '').trim()).filter(Boolean);
      if (list && tick) {
        list.replaceChildren(...items.map(text => {const li = document.createElement('li'); const span = document.createElement('span'); span.textContent = text; li.append(tick.cloneNode(true), span); return li;}));
        list.hidden = !items.length;
      }
      this.querySelectorAll('[data-terms], [data-success-terms], [data-code-block]').forEach(el => el.remove());
    }
    hasVisibleModal() {
      return [...document.querySelectorAll('dialog[open], [aria-modal="true"]')].some(el => {
        if (el === this.dialog || el.closest('[hidden], [aria-hidden="true"]')) return false;
        if (typeof el.checkVisibility === 'function') return el.checkVisibility({checkOpacity: true, checkVisibilityCSS: true});
        const style = getComputedStyle(el);
        return el.getClientRects().length > 0 && style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
      });
    }

    async attemptOpen(manual) {
      if (!this.ready || this.opening || this.dialog.open || this.dismissed || this.submitted || document.hidden) return;
      if (!manual) {
        if (this.autoDone) return;
        const height = document.documentElement.scrollHeight - window.innerHeight;
        const scrolled = height > 0 ? window.scrollY / height * 100 >= this.config.scroll_percent : this.config.scroll_percent === 0;
        if (!AIMCommunityOverlay.triggerReady(this.config.trigger, this.delayed, scrolled, this.exited)) return;
      }
      if (this.hasVisibleModal()) return;
      this.opening = true;
      const identified = await this.identity();
      if (this.isConnected && !this.dismissed && !this.hasVisibleModal() && AIMCommunityOverlay.identityAllowed(identified, this.config.hide_identified, this.config.strict_identity)) {
        if (!manual) {this.autoDone = true; this.entry = 'auto'; this.setSessionFlag('auto-shown');}
        this.open();
      }
      this.opening = false;
    }

    showPreview() {
      this.dismissed = false;
      this.submitted = false;
      if (typeof this.form.reset === 'function') this.form.reset();
      else this.form.querySelectorAll('input').forEach(input => {input.value = '';});
      this.querySelector('[data-error]').hidden = true;
      this.hideAll();
      const view = this.config.preview_view;
      if (view === 'teaser') {this.showTeaser(); return;}
      this.open();
      if (view === 'step2') this.setStep('sms');
      if (view === 'success') this.setStep('success');
    }
    hideAll() {
      if (this.dialog.open) this.dialog.close();
      this.unlock();
      this.panel.style.minHeight = '';
      this.hideTeaser();
    }

    showTeaser() {
      if (!this.config.teaser_enabled || (!this.preview && (this.dismissed || this.submitted))) return;
      const wasHidden = this.teaser.hidden;
      this.teaser.hidden = false;
      requestAnimationFrame(() => requestAnimationFrame(() => {if (!this.teaser.hidden) this.teaser.classList.add('is-visible');}));
      if (wasHidden && !this.teaserViewed) {this.teaserViewed = true; this.emit('teaser_view');}
    }
    hideTeaser() {
      this.teaser.classList.remove('is-visible');
      this.teaser.hidden = true;
    }

    firstStep() {
      return 'one';
    }
    // Email is saved before the optional native SMS consent step.
    setStep(step) {
      const success = step === 'success', email = step === 'email', intro = step === 'intro', sms = step === 'sms';
      this.dataset.step = step;
      this.querySelector('[data-pitch]').hidden = success;
      this.querySelector('[data-success]').hidden = !success;
      this.querySelector('[data-sms-confirmation]').hidden = !success || !this.smsRequested;
      this.querySelector('[data-offer]').hidden = email || sms;
      this.querySelector('[data-heading]').hidden = email || sms;
      this.querySelector('[data-sms-heading]').hidden = !sms;
      const smsSubtext = this.querySelector('[data-sms-subtext]');
      if (smsSubtext) smsSubtext.hidden = !sms;
      const smsPreview = this.querySelector('[data-sms-preview]');
      if (smsPreview) smsPreview.hidden = !sms;
      const smsLoading = this.querySelector('[data-sms-loading]');
      const smsReady = Boolean(this.klaviyoEmbed?.querySelector('input[type="tel"]'));
      if (smsLoading) smsLoading.hidden = !sms || this.preview || smsReady;
      if (this.klaviyoEmbed) this.klaviyoEmbed.hidden = success || (sms && !smsReady);
      if (smsReady) this.smsFieldMounted = true;
      this.querySelector('.aimc-pitch > .aimc-legal').hidden = sms;
      const login = this.querySelector('.aimc-login');
      if (login) login.hidden = sms;
      this.querySelector('[data-email-heading]').hidden = !email;
      const subtext = this.querySelector('[data-email-subtext]');
      if (subtext) subtext.hidden = !email || !subtext.textContent.trim();
      this.querySelector('[data-next]').hidden = !intro;
      this.form.hidden = intro || (sms && this.preview);
      this.querySelector('[data-back]').hidden = !email;
      const label = this.region?.button || this.config.button;
      this.querySelectorAll('[data-join-label]').forEach(el => el.textContent = label);
      const emailButton = this.region?.no_offer ? (this.config.noffer_email_button || this.config.email_button) : this.config.email_button;
      if (email && emailButton) {const submitLabel = this.querySelector('[data-submit] [data-join-label]'); if (submitLabel) submitLabel.textContent = emailButton;}
      this.styleEmbedButton();
      const heading = this.querySelector(success ? '[data-success-heading]' : sms ? '[data-sms-heading]' : email ? '[data-email-heading]' : '[data-heading]');
      this.dialog.setAttribute('aria-labelledby', heading.id);
      if (success || email || sms) this.dialog.removeAttribute('aria-describedby');
      else this.dialog.setAttribute('aria-describedby', this.querySelector('[data-body]').id);
      if (success) this.prepareDiscount();
      this.querySelector('.aimc-copy').scrollTop = 0;
      this.panel.scrollTop = 0;
    }

    prepareDiscount() {
      const code = this.region?.no_offer ? '' : String(this.region?.discount_code || this.config.discount_code || (this.preview ? 'AIMSHIP-DEMO' : '')).trim();
      const codeBlock = this.querySelector('[data-code-block]');
      if (codeBlock) {
        this.querySelector('[data-code]').value = code;
        codeBlock.hidden = !code;
        this.querySelector('[data-copy]').textContent = this.dataset.copyLabel;
        this.querySelector('[data-copy-status]').textContent = this.preview ? this.dataset.demo : '';
      }
      const root = this.dataset.root || '/';
      const raw = String(this.config.shop_path || '/collections/all');
      const path = /^\/(?!\/)/.test(raw) && !raw.includes('\\') ? raw : '/collections/all';
      const destination = root + path.replace(/^\//, '');
      this.querySelector('[data-shop]').href = this.preview || !code ? (this.preview ? '#' : destination) : root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(destination);
    }

    async copyCode() {
      const input = this.querySelector('[data-code]');
      if (!input.value) return;
      const status = this.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(input.value);
        if (!this.isConnected) return;
        this.querySelector('[data-copy]').textContent = this.dataset.copied;
        status.textContent = this.dataset.copied;
      } catch {
        input.focus(); input.select();
        status.textContent = this.dataset.copyFailed;
      }
    }

    syncViewport() {
      const viewport = window.visualViewport;
      if (!this.dialog.open || window.innerWidth > 700 || !viewport || viewport.scale !== 1) {
        ['--aimc-viewport-height','--aimc-viewport-top','--aimc-bottom-inset'].forEach(name => this.style.removeProperty(name));
        return;
      }
      this.style.setProperty('--aimc-viewport-height', Math.round(viewport.height) + 'px');
      this.style.setProperty('--aimc-viewport-top', Math.max(0,Math.round(viewport.offsetTop)) + 'px');
      const focusedField = this.querySelector('input:focus:not([readonly])');
      const keyboardOpen = viewport.height < window.innerHeight - 120 && focusedField;
      if (keyboardOpen) this.style.setProperty('--aimc-bottom-inset','0px');
      else this.style.removeProperty('--aimc-bottom-inset');
      if (keyboardOpen && this.panel) {
        const panelBounds = this.panel.getBoundingClientRect();
        const form = focusedField.closest('form');
        const formBounds = form && form.getBoundingClientRect();
        const targetBounds = formBounds && formBounds.height <= panelBounds.height - 24 ? formBounds : focusedField.getBoundingClientRect();
        if (targetBounds.bottom > panelBounds.bottom - 12) this.panel.scrollTop += targetBounds.bottom - panelBounds.bottom + 12;
        else if (targetBounds.top < panelBounds.top + 12) this.panel.scrollTop += targetBounds.top - panelBounds.top - 12;
      }
    }

    open() {
      if (!this.isConnected || this.dialog.open) return;
      if (!this.preview && !this.submitted && this.klaviyoEmbed && !this.klaviyoEmbed.querySelector('input[type="email"]')) {
        this.pendingOpen = true;
        return;
      }
      this.returnFocus = document.activeElement;
      this.hideTeaser();
      this.setStep(this.submitted ? 'success' : this.firstStep());
      this.oldOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.locked = true;
      this.dialog.showModal();
      this.syncViewport();
      this.querySelector(this.submitted ? '[data-success-heading]' : '[data-heading]').focus({preventScroll: true});
      if (!this.viewed) {this.viewed = true; this.emit('view');}
    }
    unlock() {
      if (this.locked) {document.documentElement.style.overflow = this.oldOverflow; this.locked = false;}
      this.syncViewport();
    }
    close() {
      if (!this.dialog.open) return;
      this.dialog.close();
      this.unlock();
      this.panel.style.minHeight = '';
      if (this.submitted) {
        this.dismissed = true;
        this.hideTeaser();
      } else if (this.config.teaser_enabled) {
        // Minimise to the teaser rather than disappearing (SunGod pattern).
        this.autoDone = true;
        if (!this.preview) {
          this.setSessionFlag('minimised');
          this.write('minimised-until', Date.now() + this.config.dismiss_days * 86400000);
          this.emit('minimise');
        }
        this.showTeaser();
      } else {
        this.dismiss();
      }
      const target = this.returnFocus?.isConnected && !this.returnFocus.closest('[hidden]') ? this.returnFocus : (this.teaser.hidden ? null : this.querySelector('[data-teaser-open]'));
      target?.focus({preventScroll: true});
    }
    dismiss() {
      this.dismissed = true;
      this.hideTeaser();
      if (!this.preview && !this.submitted) {
        // Session flag always (so the teaser stays gone on the next page), plus the
        // longer "Days hidden after dismissing" window when consent allows it.
        this.setSessionFlag('dismissed');
        this.write('dismissed-until', Date.now() + this.config.dismiss_days * 86400000);
        this.emit('dismiss');
      }
    }

    emit(action) {
      if (this.preview || !this.measurable || !this.allowed('analytics')) return;
      const detail = {event: 'aim_community_' + action, aim_variant: this.variant, aim_entry: this.entry, aim_region: this.region?.name, aim_country: this.country, aim_experiment: this.config.experiment_id};
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(detail);
      // Also publish to Shopify's Customer Events so a custom pixel can forward it to GA4.
      try {window.Shopify?.analytics?.publish?.(detail.event, detail);} catch {}
      this.dispatchEvent(new CustomEvent('aim:community', {detail, bubbles: true}));
    }

    showError(message, field) {
      const error = this.querySelector('[data-error]');
      error.textContent = message;
      error.hidden = false;
      if (field) {field.setAttribute('aria-invalid', 'true'); field.focus();}
      else error.focus();
    }

    async submit() {
      if (this.config.klaviyo_form_id && !this.preview) return;
      if (this.busy) return;
      const fields = this.form.elements || {website: this.form.querySelector('[name=website]'), email: this.emailField()};
      if (fields.website.value) return;
      const error = this.querySelector('[data-error]');
      error.hidden = true;
      const emailInput = fields.email;
      if (!emailInput.checkValidity()) {
        this.showError(this.config.email_error || this.dataset.error, emailInput);
        return;
      }
      const button = this.querySelector('[data-submit]');
      const original = [...button.childNodes].map(node => node.cloneNode(true));
      this.busy = true;
      button.disabled = true;
      button.textContent = this.dataset.pending;
      this.form.setAttribute('aria-busy', 'true');
      try {
        if (!this.preview) {
          this.requestAbort = new AbortController();
          const timeout = this.later(() => this.requestAbort.abort(), 15000);
          try {
            const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.config.site_id.trim()), {
              method: 'POST',
              headers: {'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15'},
              body: JSON.stringify(AIMCommunityOverlay.subscriptionBody(emailInput.value, this.config.list_id.trim(), {region: this.region.name, country: this.country, variant: 'A', entry: this.entry, offer: this.region.no_offer ? 'none' : 'first_order_free_shipping'})),
              signal: this.requestAbort.signal,
              credentials: 'omit'
            });
            if (response.status !== 202) throw new Error(response.status === 429 ? 'rate' : 'request');
          } finally {clearTimeout(timeout);}
        }
        if (!this.isConnected) return;
        this.panel.style.minHeight = this.panel.offsetHeight + 'px';
        this.submitted = true;
        if (!this.preview) {
          this.write('subscribed-until', Date.now() + 365 * 86400000);
          this.setSessionFlag('subscribed');
          this.emit('request_accepted');
        }
        this.setStep(this.preview && this.smsAvailable() ? 'sms' : 'success');
        this.querySelector(this.dataset.step === 'sms' ? '[data-sms-heading]' : '[data-success-heading]').focus();
      } catch (e) {
        if (!this.isConnected) return;
        this.showError(e.message === 'rate' ? this.dataset.rateError : this.dataset.error);
      } finally {
        this.busy = false;
        button.disabled = false;
        button.replaceChildren(...original);
        this.form.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('aim-community-overlay', AIMCommunityOverlay);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-community-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aim-community-gallery')) {
    customElements.define('aim-community-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-ugc-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        this.navigation = this.querySelector('[data-ugc-navigation]');
        this.videos = [...this.track.querySelectorAll('video')];
        this.openers = [...this.track.querySelectorAll('[data-ugc-open]')];
        this.templates = [...this.track.querySelectorAll('[data-ugc-full]')];
        this.dialog = this.querySelector('[data-ugc-dialog]');
        this.stage = this.querySelector('[data-ugc-modal-media]');
        this.modalPrevious = this.querySelector('[data-ugc-modal-prev]');
        this.modalNext = this.querySelector('[data-ugc-modal-next]');
        this.counter = this.querySelector('[data-ugc-counter]');
        this.playbackStatus = this.querySelector('[data-ugc-playback-status]');
        this.visibility = new Map();
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.suppressClickUntil = 0;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = this.rtl ? -1 : 1;
          if (event.key === 'ArrowRight') this.move(direction);
          else if (event.key === 'ArrowLeft') this.move(-direction);
          else if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.track.scrollWidth - this.track.clientWidth);
          else return;
          event.preventDefault();
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          const distance = event.clientX - drag.x;
          if (!drag.active) {
            if (Math.abs(distance) < 6 || Math.abs(distance) < Math.abs(event.clientY - drag.y)) return;
            drag.active = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
          }
          event.preventDefault();
          this.track.scrollLeft = drag.left - distance;
        }, options);
        const endDrag = () => {
          if (!this.drag) return;
          if (this.drag.active) {
            this.suppressClickUntil = performance.now() + 350;
            if (this.track.hasPointerCapture?.(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
          }
          this.drag = null;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('lostpointercapture', endDrag, options);
        this.track.addEventListener('pointerleave', event => { if (!this.drag?.active) endDrag(); }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });
        this.openers.forEach((opener, index) => opener.addEventListener('click', () => this.openModal(index, opener), options));
        this.querySelector('[data-ugc-close]')?.addEventListener('click', () => this.closeModal(), options);
        this.modalPrevious?.addEventListener('click', () => this.renderModal(this.modalIndex - 1), options);
        this.modalNext?.addEventListener('click', () => this.renderModal(this.modalIndex + 1), options);
        this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.closeModal(); }, options);
        this.dialog?.addEventListener('cancel', event => { event.preventDefault(); this.closeModal(); }, options);
        this.dialog?.addEventListener('close', () => this.finishClose(), options);
        this.dialog?.addEventListener('keydown', event => {
          if (event.key === 'Tab') {
            const controls = [...this.dialog.querySelectorAll('button:not(:disabled)')];
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
            return;
          }
          if (event.key === 'Escape') { event.preventDefault(); this.closeModal(); }
          else if (event.target.tagName !== 'VIDEO' && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
            this.renderModal(this.modalIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        document.addEventListener('play', event => {
          if (!event.target.matches?.('aim-community-gallery video')) return;
          if (event.target.closest('[data-ugc-track]')) {
            if (document.querySelector('aim-community-gallery dialog[open]')) event.target.pause();
            return;
          }
          document.querySelectorAll('aim-community-gallery video').forEach(video => {
            if (video !== event.target && !video.paused) video.pause();
          });
        }, { ...options, capture: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.pauseVideos(); this.stage?.querySelector('video')?.pause(); }
          else this.syncPreview();
        }, options);
        this.reducedMotion.addEventListener?.('change', () => this.syncPreview(), options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => this.visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
            this.syncPreview();
          }, { threshold: [0, .2, .5, .75, 1] });
          this.videos.forEach(video => this.visibilityObserver.observe(video));
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.track);
        }
        this.updateNavigation();
      }
      syncPreview() {
        if (!this.videos) return;
        const canPlay = this.isConnected && !document.hidden && !document.querySelector('aim-community-gallery dialog[open]') && !this.reducedMotion.matches;
        this.videos.forEach(video => {
          if (!canPlay || (this.visibility.get(video) || 0) < .5) { if (!video.paused) video.pause(); return; }
          video.muted = true;
          video.loop = true;
          if (video.paused) video.play().catch(() => {});
        });
      }
      openModal(index, opener) {
        document.querySelectorAll('aim-community-gallery').forEach(gallery => { if (gallery !== this) gallery.closeModal?.(); });
        this.returnFocus = opener;
        document.querySelectorAll('aim-community-gallery').forEach(gallery => gallery.pauseVideos?.());
        this.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.renderModal(index);
      }
      renderModal(index) {
        if (index < 0 || index >= this.templates.length) return;
        this.stage.querySelector('video')?.pause();
        this.stage.replaceChildren(this.templates[index].content.cloneNode(true));
        this.modalIndex = index;
        this.modalPrevious.setAttribute('aria-disabled', String(index === 0));
        this.modalNext.setAttribute('aria-disabled', String(index === this.templates.length - 1));
        this.counter.textContent = `${index + 1} / ${this.templates.length}`;
        this.playbackStatus.textContent = '';
        const video = this.stage.querySelector('video');
        if (video) {
          video.muted = false;
          video.volume = 1;
          video.loop = true;
          // Keep playback in the click gesture so browsers permit immediate sound.
          video.play().catch(() => {
            if (this.dialog.open && video === this.stage.querySelector('video')) this.playbackStatus.textContent = this.playbackStatus.dataset.message || '';
          });
        }
      }
      closeModal() { if (this.dialog?.open) this.dialog.close(); }
      finishClose() {
        this.stage?.querySelector('video')?.pause();
        this.stage?.replaceChildren();
        if (this.savedOverflow !== undefined) document.documentElement.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
        document.querySelectorAll('aim-community-gallery').forEach(gallery => gallery.syncPreview?.());
      }
      updateNavigation() {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.navigation) this.navigation.hidden = maximum < 2;
        if (this.previous) this.previous.disabled = position < 2;
        if (this.next) this.next.disabled = position >= maximum - 2;
      }
      move(direction) {
        const cards = this.track.querySelectorAll('[data-ugc-card]');
        const step = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : this.track.clientWidth;
        this.goTo(Math.abs(this.track.scrollLeft) + direction * step);
      }
      goTo(position) {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const left = Math.max(0, Math.min(maximum, position)) * (this.rtl ? -1 : 1);
        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
      pauseVideos() { this.videos?.forEach(video => { if (!video.paused) video.pause(); }); }
      disconnectedCallback() {
        this.pauseVideos();
        this.closeModal();
        this.finishClose();
        this.drag = null;
        this.track?.classList.remove('is-dragging');
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-editorial-collection"]) return;
  try {
    
  const currentUrl = new URL(window.location.href);

  if (currentUrl.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(currentUrl.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'auto' });
      },
      { once: true }
    );
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-aim-filter-form]').forEach((form) => {
      form.querySelectorAll('select, input[type="checkbox"]').forEach((control) => {
        control.addEventListener('change', () => form.submit());
      });
    });

    document.querySelectorAll('[data-aim-collection-tabs]').forEach((scroller) => {
      const activeTab = scroller.querySelector('[data-active-tab]');
      if (!activeTab || window.matchMedia('(min-width: 750px)').matches) return;

      const desiredLeft = activeTab.offsetLeft - (scroller.clientWidth - activeTab.offsetWidth) / 2;
      scroller.scrollTo({ left: Math.max(0, desiredLeft), behavior: 'auto' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-page-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aim-page-gallery')) {
    customElements.define('aim-page-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('[data-ugc-track]');
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-ugc-prev]');
        this.next = this.querySelector('[data-ugc-next]');
        this.navigation = this.querySelector('[data-ugc-navigation]');
        this.videos = [...this.track.querySelectorAll('video')];
        this.cards = [...this.track.querySelectorAll('[data-ugc-card]')];
        this.openers = [...this.track.querySelectorAll('[data-ugc-open]')];
        this.templates = [...this.track.querySelectorAll('[data-ugc-full]')];
        this.dialog = this.querySelector('[data-ugc-dialog]');
        this.stage = this.querySelector('[data-ugc-modal-media]');
        this.modalPrevious = this.querySelector('[data-ugc-modal-prev]');
        this.modalNext = this.querySelector('[data-ugc-modal-next]');
        this.counter = this.querySelector('[data-ugc-counter]');
        this.playbackStatus = this.querySelector('[data-ugc-playback-status]');
        this.visibility = new Map();
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.suppressClickUntil = 0;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = this.rtl ? -1 : 1;
          if (event.key === 'ArrowRight') this.move(direction);
          else if (event.key === 'ArrowLeft') this.move(-direction);
          else if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.track.scrollWidth - this.track.clientWidth);
          else return;
          event.preventDefault();
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          const distance = event.clientX - drag.x;
          if (!drag.active) {
            if (Math.abs(distance) < 6 || Math.abs(distance) < Math.abs(event.clientY - drag.y)) return;
            drag.active = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
          }
          event.preventDefault();
          this.track.scrollLeft = drag.left - distance;
        }, options);
        const endDrag = () => {
          if (!this.drag) return;
          if (this.drag.active) {
            this.suppressClickUntil = performance.now() + 350;
            if (this.track.hasPointerCapture?.(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
          }
          this.drag = null;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('lostpointercapture', endDrag, options);
        this.track.addEventListener('pointerleave', event => { if (!this.drag?.active) endDrag(); }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });
        this.openers.forEach((opener, index) => opener.addEventListener('click', () => this.openModal(index, opener), options));
        this.querySelector('[data-ugc-close]')?.addEventListener('click', () => this.closeModal(), options);
        this.modalPrevious?.addEventListener('click', () => this.renderModal(this.modalIndex - 1), options);
        this.modalNext?.addEventListener('click', () => this.renderModal(this.modalIndex + 1), options);
        this.dialog?.addEventListener('click', event => { if (event.target === this.dialog) this.closeModal(); }, options);
        this.dialog?.addEventListener('cancel', event => { event.preventDefault(); this.closeModal(); }, options);
        this.dialog?.addEventListener('close', () => this.finishClose(), options);
        this.dialog?.addEventListener('keydown', event => {
          if (event.key === 'Tab') {
            const controls = [...this.dialog.querySelectorAll('button:not(:disabled)')];
            const first = controls[0];
            const last = controls[controls.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
            return;
          }
          if (event.key === 'Escape') { event.preventDefault(); this.closeModal(); }
          else if (event.target.tagName !== 'VIDEO' && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
            event.preventDefault();
            this.renderModal(this.modalIndex + (event.key === 'ArrowRight' ? 1 : -1));
          }
        }, options);
        document.addEventListener('play', event => {
          if (!event.target.matches?.('aim-page-gallery video')) return;
          if (event.target.closest('[data-ugc-track]')) {
            if (document.querySelector('aim-page-gallery dialog[open]')) event.target.pause();
            return;
          }
          document.querySelectorAll('aim-page-gallery video').forEach(video => {
            if (video !== event.target && !video.paused) video.pause();
          });
        }, { ...options, capture: true });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) { this.pauseVideos(); this.stage?.querySelector('video')?.pause(); }
          else this.syncPreview();
        }, options);
        // Theme editor: scroll the selected block into view.
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
          if (!card) return;
          this.goTo(Math.abs(card.offsetLeft - this.track.offsetLeft));
        }, options);
        this.reducedMotion.addEventListener?.('change', () => this.syncPreview(), options);
        if ('IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => this.visibility.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0));
            this.syncPreview();
          }, { threshold: [0, .2, .5, .75, 1] });
          this.videos.forEach(video => this.visibilityObserver.observe(video));
        }
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.track);
        }
        this.updateNavigation();
      }
      syncPreview() {
        if (!this.videos) return;
        const canPlay = this.isConnected && !document.hidden && !document.querySelector('aim-page-gallery dialog[open]') && !this.reducedMotion.matches;
        this.videos.forEach(video => {
          if (!canPlay || (this.visibility.get(video) || 0) < .5) { if (!video.paused) video.pause(); return; }
          video.muted = true;
          video.loop = true;
          if (video.paused) video.play().catch(() => {});
        });
      }
      openModal(index, opener) {
        document.querySelectorAll('aim-page-gallery').forEach(gallery => { if (gallery !== this) gallery.closeModal?.(); });
        this.returnFocus = opener;
        document.querySelectorAll('aim-page-gallery').forEach(gallery => gallery.pauseVideos?.());
        this.savedOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        this.renderModal(index);
      }
      renderModal(index) {
        if (index < 0 || index >= this.templates.length) return;
        this.stage.querySelector('video')?.pause();
        this.stage.replaceChildren(this.templates[index].content.cloneNode(true));
        this.modalIndex = index;
        this.modalPrevious.setAttribute('aria-disabled', String(index === 0));
        this.modalNext.setAttribute('aria-disabled', String(index === this.templates.length - 1));
        this.counter.textContent = `${index + 1} / ${this.templates.length}`;
        this.playbackStatus.textContent = '';
        const video = this.stage.querySelector('video');
        if (video) {
          video.muted = false;
          video.volume = 1;
          video.loop = true;
          // Keep playback in the click gesture so browsers permit immediate sound.
          video.play().catch(() => {
            if (this.dialog.open && video === this.stage.querySelector('video')) this.playbackStatus.textContent = this.playbackStatus.dataset.message || '';
          });
        }
      }
      closeModal() { if (this.dialog?.open) this.dialog.close(); }
      finishClose() {
        this.stage?.querySelector('video')?.pause();
        this.stage?.replaceChildren();
        if (this.savedOverflow !== undefined) document.documentElement.style.overflow = this.savedOverflow;
        this.savedOverflow = undefined;
        if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
        this.returnFocus = null;
        document.querySelectorAll('aim-page-gallery').forEach(gallery => gallery.syncPreview?.());
      }
      updateNavigation() {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.navigation) this.navigation.hidden = maximum < 2;
        if (this.previous) this.previous.disabled = position < 2;
        if (this.next) this.next.disabled = position >= maximum - 2;
      }
      move(direction) {
        const cards = this.track.querySelectorAll('[data-ugc-card]');
        const step = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : this.track.clientWidth;
        this.goTo(Math.abs(this.track.scrollLeft) + direction * step);
      }
      goTo(position) {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const left = Math.max(0, Math.min(maximum, position)) * (this.rtl ? -1 : 1);
        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
      pauseVideos() { this.videos?.forEach(video => { if (!video.paused) video.pause(); }); }
      disconnectedCallback() {
        this.pauseVideos();
        this.closeModal();
        this.finishClose();
        this.drag = null;
        this.track?.classList.remove('is-dragging');
        this.controller?.abort();
        this.visibilityObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aim-pdp-sticky"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('aim-pdp-sticky')) {
    customElements.define('aim-pdp-sticky', class extends HTMLElement {

      connectedCallback() {
        this.hidden = true;
        this.inert = true;

        this.controller = new AbortController();

        this.frame = 0;
        this.variantPending = false;
        this.cartPending = false;

        this.details = null;
        this.nativeButton = null;

        this.button = this.querySelector(
          '[data-aim-sticky-submit]'
        );

        this.buttonLabelNode = this.querySelector(
          '[data-aim-sticky-button-label]'
        );

        this.titleNode = this.querySelector(
          '[data-aim-sticky-title]'
        );

        this.optionNode = this.querySelector(
          '[data-aim-sticky-option]'
        );

        this.priceNode = this.querySelector(
          '[data-aim-sticky-price]'
        );

        if (
          !this.button ||
          !this.buttonLabelNode ||
          !this.titleNode ||
          !this.optionNode ||
          !this.priceNode
        ) {
          return;
        }

        const { signal } = this.controller;


        /* =====================================================
           SCHEDULE UPDATE
           ===================================================== */

        this.scheduleUpdate = () => {
          if (
            this.frame ||
            !this.isConnected
          ) {
            return;
          }

          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.update();
          });
        };


        /* =====================================================
           STICKY BUTTON CLICK
           ===================================================== */

        this.button.addEventListener(
          'click',
          () => {

            this.update();

            if (
              this.hidden ||
              this.button.disabled ||
              !this.nativeButton?.isConnected
            ) {
              return;
            }

            const form = this.nativeButton.form;

            const quantity = form?.querySelector(
              'quantity-selector-component'
            );

            const quantityValid =
              !quantity?.canAddToCart ||
              quantity.canAddToCart().canAdd;

            this.cartPending = Boolean(
              form?.checkValidity() &&
              quantityValid
            );

            this.nativeButton.click();

            this.scheduleUpdate();

          },
          { signal }
        );


        /* =====================================================
           PAGE EVENTS
           ===================================================== */

        window.addEventListener(
          'scroll',
          this.scheduleUpdate,
          {
            passive: true,
            signal
          }
        );

        window.addEventListener(
          'resize',
          this.scheduleUpdate,
          {
            passive: true,
            signal
          }
        );

        window.visualViewport?.addEventListener(
          'resize',
          this.scheduleUpdate,
          {
            passive: true,
            signal
          }
        );

        document.addEventListener(
          'shopify:section:load',
          this.scheduleUpdate,
          { signal }
        );

        document.addEventListener(
          'shopify:section:unload',
          this.scheduleUpdate,
          { signal }
        );

        document.addEventListener(
          'dialog:open',
          this.scheduleUpdate,
          { signal }
        );

        document.addEventListener(
          'dialog:close',
          this.scheduleUpdate,
          { signal }
        );

        document.addEventListener(
          'toggle',
          this.scheduleUpdate,
          {
            capture: true,
            signal
          }
        );


        /* =====================================================
           VARIANT EVENTS
           ===================================================== */

        document.addEventListener(
          'variant:selected',
          (event) => {

            if (!this.isMainEvent(event)) {
              return;
            }

            this.variantPending = true;

            this.setVisible(false);

            this.scheduleUpdate();

          },
          { signal }
        );

        document.addEventListener(
          'variant:update',
          (event) => {

            if (!this.isMainEvent(event)) {
              return;
            }

            this.variantPending = false;

            this.scheduleUpdate();

          },
          { signal }
        );

        document.addEventListener(
          'change',
          (event) => {

            if (this.isMainEvent(event)) {
              this.scheduleUpdate();
            }

          },
          { signal }
        );


        /* =====================================================
           CART EVENTS
           ===================================================== */

        ['cart:update', 'cart:error'].forEach(
          (eventName) => {

            document.addEventListener(
              eventName,
              (event) => {

                if (!this.isMainEvent(event)) {
                  return;
                }

                this.cartPending = false;

                this.scheduleUpdate();

              },
              { signal }
            );

          }
        );


        /* =====================================================
           DOM OBSERVER
           ===================================================== */

        this.observer = new MutationObserver(
          (records) => {

            if (
              records.some(
                (record) =>
                  !this.contains(record.target)
              )
            ) {
              this.scheduleUpdate();
            }

          }
        );

        this.observer.observe(
          document.body,
          {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,

            attributeFilter: [
              'open',
              'hidden',
              'inert',
              'disabled',
              'aria-disabled',
              'aria-busy',
              'aria-hidden',
              'aria-modal',
              'class',
              'style',
              'data-product-id',
              'value',
              'checked'
            ]
          }
        );

        this.scheduleUpdate();
      }


      /* =====================================================
         DISCONNECT
         ===================================================== */

      disconnectedCallback() {
        this.controller?.abort();

        this.observer?.disconnect();

        if (this.frame) {
          cancelAnimationFrame(this.frame);
        }

        this.frame = 0;
        this.details = null;
        this.nativeButton = null;

        this.hidden = true;
        this.inert = true;
      }


      /* =====================================================
         IS MAIN PRODUCT EVENT
         ===================================================== */

      isMainEvent(event) {
        return (
          event.target instanceof Element &&
          Boolean(
            this.details?.contains(event.target)
          ) &&
          !event.target.closest(
            'product-card, product-recommendations, quick-add-component, dialog'
          )
        );
      }


      /* =====================================================
         FIND MAIN PRODUCT
         ===================================================== */

      findMainDetails() {
        const main = document.querySelector('main');

        if (!main) {
          return null;
        }

        return (
          Array.from(
            main.querySelectorAll(
              '.product-information [id^="ProductInformation-"]'
            )
          ).find(
            (details) =>
              !details.closest(
                'product-card, product-recommendations, quick-add-component, dialog'
              )
          ) ||
          null
        );
      }


      /* =====================================================
         QUERY MAIN PRODUCT
         ===================================================== */

      mainQuery(selector) {
        if (!this.details) {
          return null;
        }

        return (
          Array.from(
            this.details.querySelectorAll(selector)
          ).find(
            (element) =>
              !element.closest(
                'product-card, product-recommendations, quick-add-component, dialog'
              )
          ) ||
          null
        );
      }


      /* =====================================================
         SET TEXT
         ===================================================== */

      setText(element, text) {
        if (element.textContent !== text) {
          element.textContent = text;
        }
      }


      /* =====================================================
         VISIBILITY
         ===================================================== */

      setVisible(visible) {
        this.hidden = !visible;
        this.inert = !visible;
      }


      /* =====================================================
         OVERLAYS
         ===================================================== */

      overlayIsOpen() {

        if (
          document.querySelector(
            'dialog[open], header-drawer details[open], #header-component.aim-mobile-menu-open, #header-component.aim-editorial-menu-open'
          )
        ) {
          return true;
        }

        return Array.from(
          document.querySelectorAll(
            '[aria-modal="true"], [role="dialog"], .drawer.is-open, .drawer.active, .modal.is-open, .modal.active'
          )
        ).some(
          (overlay) => {

            if (
              overlay.closest(
                '[hidden], [inert], [aria-hidden="true"]'
              )
            ) {
              return false;
            }

            const style = getComputedStyle(overlay);

            return (
              style.display !== 'none' &&
              style.visibility !== 'hidden' &&
              Number(style.opacity) !== 0 &&
              overlay.getClientRects().length > 0
            );

          }
        );
      }


      /* =====================================================
         SELECTED OPTION
         ===================================================== */

      selectedOption() {

        const picker =
          this.mainQuery(
            'variant-picker.aim-lens-picker'
          ) ||
          this.mainQuery(
            'variant-picker'
          );

        if (!picker) {
          return '';
        }

        return Array.from(
          picker.querySelectorAll(
            'input[type="radio"]:checked, select'
          )
        )
          .filter(
            (input) =>
              !input.closest('[hidden]')
          )
          .map(
            (input) =>
              input.value.trim()
          )
          .filter(Boolean)
          .join(' / ');
      }


      /* =====================================================
         UPDATE
         ===================================================== */

      update() {

        if (
          !this.isConnected ||
          !this.button
        ) {
          return;
        }


        /* -----------------------------------------------------
           Main product
           ----------------------------------------------------- */

        const details = this.findMainDetails();

        if (details !== this.details) {
          this.details = details;

          this.variantPending = false;
          this.cartPending = false;
        }


        /* -----------------------------------------------------
           Native product form

           IMPORTANT:
           Keep these selectors exactly as below.
           ----------------------------------------------------- */

        const formComponent = this.mainQuery(
          'product-form-component[data-product-id]'
        );

        const form = formComponent?.querySelector(
          'form[data-type="add-to-cart-form"]'
        );

        this.nativeButton = form?.querySelector(
          'button[ref="addToCartButton"]'
        );

        const nativePrice = this.mainQuery(
          'product-price .price'
        );

        const nativeTitle =
          this.mainQuery('h1') ||
          this.mainQuery('.view-product-title a');

        const variantId = form?.querySelector(
          'input[name="id"]'
        )?.value;

        const nativeFormReady = Boolean(
          this.nativeButton &&
          form &&
          nativePrice &&
          nativeTitle &&
          variantId
        );

        if (!nativeFormReady) {
          this.button.disabled = true;

          this.setVisible(false);

          return;
        }


        /* -----------------------------------------------------
           State
           ----------------------------------------------------- */

        const busy =
          this.variantPending ||
          this.cartPending ||
          this.nativeButton.getAttribute(
            'aria-busy'
          ) === 'true' ||
          formComponent.getAttribute(
            'aria-busy'
          ) === 'true' ||
          this.nativeButton.classList.contains(
            'loading'
          ) ||
          this.nativeButton.classList.contains(
            'atc-added'
          );

const nativeDisabled =
  this.nativeButton.disabled ||
  this.nativeButton.getAttribute('aria-disabled') === 'true';

this.button.disabled =
  busy ||
  nativeDisabled;

this.button.setAttribute(
  'aria-busy',
  String(busy)
);


/* -----------------------------------------------------
   Button label

   Available variant:
   Always use clean "Add to cart" label because the
   native PDP button may already contain its own price.

   Unavailable variant:
   Use native label so states such as "Sold out" remain.
   ----------------------------------------------------- */

const nativeLabel = this.nativeButton
  .querySelector('.add-to-cart-text__content')
  ?.textContent
  .trim();

let stickyLabel = this.dataset.defaultLabel;

if (busy) {
  stickyLabel = this.dataset.updatingLabel;
} else if (nativeDisabled && nativeLabel) {
  stickyLabel = nativeLabel;
}

this.setText(
  this.buttonLabelNode,
  stickyLabel
);

        /* -----------------------------------------------------
           Product data
           ----------------------------------------------------- */

        this.setText(
          this.titleNode,
          nativeTitle.textContent.trim()
        );

        this.setText(
          this.optionNode,
          this.selectedOption()
        );

        this.setText(
          this.priceNode,
          nativePrice.textContent.trim()
        );


        /* -----------------------------------------------------
           Device visibility
           ----------------------------------------------------- */

        const mobile = window.matchMedia(
          '(max-width: 749px)'
        ).matches;

        const enabled = mobile
          ? this.dataset.mobile === 'true'
          : this.dataset.desktop === 'true';


        /* -----------------------------------------------------
           Show after main ATC leaves viewport
           ----------------------------------------------------- */

        const nativeBounds =
          this.nativeButton.getBoundingClientRect();

        const passedMainButton =
          this.nativeButton.getClientRects().length > 0 &&
          nativeBounds.bottom < 0;


        /* -----------------------------------------------------
           Footer
           ----------------------------------------------------- */

        const viewportHeight =
          window.visualViewport?.height ||
          window.innerHeight;

        const footerClearance =
          Number(
            this.dataset.footerClearance
          ) ||
          0;

        const footer = document.querySelector(
          '#footer-group, .shopify-section-group-footer-group, footer[role="contentinfo"], body > footer'
        );

        const nearFooter =
          footer &&
          footer.getBoundingClientRect().top <=
            viewportHeight +
            footerClearance;


        /* -----------------------------------------------------
           Mobile keyboard
           ----------------------------------------------------- */

        const keyboardOpen =
          window.visualViewport &&
          window.innerHeight -
            window.visualViewport.height >
            150;


        /* -----------------------------------------------------
           Final visibility
           ----------------------------------------------------- */

        this.setVisible(
          Boolean(
            enabled &&
            passedMainButton &&
            !nearFooter &&
            !keyboardOpen &&
            !this.variantPending &&
            !this.overlayIsOpen()
          )
        );
      }

    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aim-product-carousel')) {
    customElements.define('aim-product-carousel', class extends HTMLElement {
      connectedCallback() {
        // Shopify can hydrate the existing element instead of reconnecting it.
        this.mutationObserver = new MutationObserver(() => this.refresh());
        this.mutationObserver.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-aim-track'] });
        this.refresh();
      }
      refresh() {
        const track = this.querySelector('[data-aim-track]');
        if (track === this.track && this.controller && this.previous === this.querySelector('[data-aim-prev]') && this.next === this.querySelector('[data-aim-next]')) {
          this.updateNavigation();
          return;
        }
        this.clearListeners();
        this.track = track;
        if (!this.track) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous = this.querySelector('[data-aim-prev]');
        this.next = this.querySelector('[data-aim-next]');
        this.navigation = this.querySelector('[data-aim-navigation]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        this.suppressClickUntil = 0;
        this.previous?.addEventListener('click', () => this.move(-1), options);
        this.next?.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const direction = this.rtl ? -1 : 1;
          if (event.key === 'ArrowRight') this.move(direction);
          else if (event.key === 'ArrowLeft') this.move(-direction);
          else if (event.key === 'Home') this.goTo(0);
          else if (event.key === 'End') this.goTo(this.track.scrollWidth - this.track.clientWidth);
          else return;
          event.preventDefault();
        }, options);
        this.track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, select, textarea, video, slideshow-component')) return;
          this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
        }, options);
        this.track.addEventListener('pointermove', event => {
          const drag = this.drag;
          if (!drag || drag.id !== event.pointerId) return;
          const distance = event.clientX - drag.x;
          if (!drag.active) {
            if (Math.abs(distance) < 6 || Math.abs(distance) < Math.abs(event.clientY - drag.y)) return;
            drag.active = true;
            this.track.setPointerCapture(event.pointerId);
            this.track.classList.add('is-dragging');
          }
          event.preventDefault();
          this.track.scrollLeft = drag.left - distance;
        }, options);
        const endDrag = () => {
          if (!this.drag) return;
          if (this.drag.active) {
            this.suppressClickUntil = performance.now() + 350;
            if (this.track.hasPointerCapture?.(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
          }
          this.drag = null;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('lostpointercapture', endDrag, options);
        this.track.addEventListener('pointerleave', event => { if (!this.drag?.active) endDrag(); }, options);
        this.track.addEventListener('dragstart', event => event.preventDefault(), options);
        this.track.addEventListener('click', event => {
          if (performance.now() < this.suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, { ...options, capture: true });
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
          this.resizeObserver.observe(this.track);
        }
        window.addEventListener('resize', () => this.updateNavigation(), options);
        this.updateNavigation();
      }
      updateNavigation() {
        const position = Math.abs(this.track.scrollLeft);
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.navigation) this.navigation.hidden = maximum < 2;
        if (this.previous) this.previous.disabled = position < 2;
        if (this.next) this.next.disabled = position >= maximum - 2;
      }
      move(direction) {
        const cards = this.track.querySelectorAll(':scope > .resource-list__item');
        const step = cards.length > 1 ? Math.abs(cards[1].offsetLeft - cards[0].offsetLeft) : this.track.clientWidth;
        this.goTo(Math.abs(this.track.scrollLeft) + direction * step);
      }
      goTo(position) {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        const left = Math.max(0, Math.min(maximum, position)) * (this.rtl ? -1 : 1);
        this.track.scrollTo({ left, behavior: this.reducedMotion.matches ? 'auto' : 'smooth' });
      }
      clearListeners() {
        this.drag = null;
        this.track?.classList.remove('is-dragging');
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.controller = null;
      }
      disconnectedCallback() {
        this.clearListeners();
        this.mutationObserver?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-parallax-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('scroll-parallax-hero')) {
    class ScrollParallaxHero extends HTMLElement {
      constructor() {
        super();
        this.panels = [];
        this.titleButtons = [];
        this.discoverLinks = [];
        this.videos = [];
        this.rafId = null;
        this.videoObserver = null;
        this.prefersReducedMotion = false;
        this._onScroll = this._onScroll.bind(this);
      }

      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-panel-id]'));
        this.titleButtons = Array.from(this.querySelectorAll('[data-panel-target]'));
        this.discoverLinks = Array.from(this.querySelectorAll('[data-discover-for]'));
        this.videos = Array.from(this.querySelectorAll('video[data-autoplay-on-intersect]'));

        const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.prefersReducedMotion = mq.matches;
        mq.addEventListener('change', (e) => { this.prefersReducedMotion = e.matches; });

        this._setupVideoObserver();
        this._setupClicks();

        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll, { passive: true });

        // Initial state
        this._update();
      }

      disconnectedCallback() {
        if (this.videoObserver) this.videoObserver.disconnect();
        window.removeEventListener('scroll', this._onScroll);
        window.removeEventListener('resize', this._onScroll);
        if (this.rafId) cancelAnimationFrame(this.rafId);
      }

      _setupVideoObserver() {
        if (!('IntersectionObserver' in window)) return;
        this.videoObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const video = entry.target;
            const threshold = parseFloat(video.dataset.autoplayOnIntersect) || 0.5;
            if (entry.isIntersecting && entry.intersectionRatio >= threshold) {
              if (this.prefersReducedMotion) return;
              const p = video.play();
              if (p && typeof p.catch === 'function') p.catch(() => { /* autoplay blocked, ignore */ });
            } else {
              video.pause();
            }
          });
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

        this.videos.forEach((v) => this.videoObserver.observe(v));
      }

      _setupClicks() {
        this.titleButtons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            const target = btn.dataset.panelTarget;
            const href = btn.dataset.href;
            const isActive = this.dataset.active === target;

            if (isActive && href) {
              window.location.href = href;
              return;
            }

            const panel = this.querySelector('[data-panel-id="' + target + '"]');
            if (panel) {
              const behavior = this.prefersReducedMotion ? 'auto' : 'smooth';
              panel.scrollIntoView({ behavior: behavior, block: 'start' });
            }
          });
        });
      }

      _onScroll() {
        if (this.rafId) return;
        this.rafId = requestAnimationFrame(() => {
          this._update();
          this.rafId = null;
        });
      }

      _update() {
        if (!this.panels.length) return;
        const viewportCenter = window.innerHeight / 2;
        let closestPanel = null;
        let closestDistance = Infinity;

        for (let i = 0; i < this.panels.length; i++) {
          const rect = this.panels[i].getBoundingClientRect();
          const center = rect.top + rect.height / 2;
          const distance = Math.abs(center - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestPanel = this.panels[i];
          }
        }

        if (!closestPanel) return;
        const id = closestPanel.dataset.panelId;
        if (this.dataset.active === id) return;

        this.dataset.active = id;

        // Update title buttons
        for (let i = 0; i < this.titleButtons.length; i++) {
          const btn = this.titleButtons[i];
          const match = btn.dataset.panelTarget === id;
          if (match) {
            btn.setAttribute('data-active', '');
            btn.setAttribute('aria-selected', 'true');
          } else {
            btn.removeAttribute('data-active');
            btn.setAttribute('aria-selected', 'false');
          }
        }

        // Update discover links
        for (let i = 0; i < this.discoverLinks.length; i++) {
          const link = this.discoverLinks[i];
          if (link.dataset.discoverFor === id) {
            link.setAttribute('data-active', '');
          } else {
            link.removeAttribute('data-active');
          }
        }
      }
    }

    customElements.define('scroll-parallax-hero', ScrollParallaxHero);
  }

  } catch(e) { console.error(e); }
})();
})();
